export interface IAd2cpEnable {
    'module-AD2CP':boolean
}

export const getDefaultAd2cpEnable = ():IAd2cpEnable => {
    return {
        'module-AD2CP':true
    }
}